import {
  createSystem,
  defaultConfig,
  defineConfig,
  mergeConfigs,
} from "@chakra-ui/react";

const customConfig = defineConfig({
  globalCss: {
    "::-webkit-scrollbar": {
      backgroundColor: "transparent",
      width: "0.2rem",
      height: "0.2rem",
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "secondary.4",
      borderRadius: "0.5rem",
    },
    "::-webkit-scrollbar-button": { display: "none" },
  },
  theme: {
    semanticTokens: {
      colors: {
        defaultBackground: {
          value: { base: "#FFFFFF", _dark: "#1f1e1d" },
        },
        primary: {
          0: {
            value: { base: "#CDE4FF", _dark: "#001834" },
          },
          1: {
            value: { base: "#A4CEFF", _dark: "#003878" },
          },
          2: {
            value: { base: "#7AB8FF", _dark: "#0056B9" },
          },
          3: {
            value: { base: "#52A2FF", _dark: "#0C6FE2" },
          },
          4: {
            value: { base: "#288BFE", _dark: "#288BFE" },
          },
          5: {
            value: { base: "#0C6FE2", _dark: "#52A2FF" },
          },
          6: {
            value: { base: "#0056B9", _dark: "#7AB8FF" },
          },
          7: {
            value: { base: "#003878", _dark: "#A4CEFF" },
          },
          8: {
            value: { base: "#001834", _dark: "#CDE4FF" },
          },
        },

        secondary: {
          0: {
            value: { base: "#F8F8FB", _dark: "#2C2C2E" },
          },
          1: {
            value: { base: "#E5E5EA", _dark: "#3A3A3C" },
          },
          2: {
            value: { base: "#D1D1D6", _dark: "#48484A" },
          },
          3: {
            value: { base: "#C7C7CC", _dark: "#636366" },
          },
          4: {
            value: { base: "#AEAEB2", _dark: "#8E8E93" },
          },
          5: {
            value: { base: "#8E8E93", _dark: "#AEAEB2" },
          },
          6: {
            value: { base: "#636366", _dark: "#C7C7CC" },
          },
          7: {
            value: { base: "#48484A", _dark: "#D1D1D6" },
          },
          8: {
            value: { base: "#3A3A3C", _dark: "#E5E5EA" },
          },
        },

        text: {
          0: {
            value: { base: "#8E8E93", _dark: "#8E8E93" },
          },
          1: {
            value: { base: "#636366", _dark: "#AEAEB2" },
          },
          2: {
            value: { base: "#48484A", _dark: "#C7C7CC" },
          },
          3: {
            value: { base: "#3A3A3C", _dark: "#D1D1D6" },
          },
          4: {
            value: { base: "#2C2C2E", _dark: "#E5E5EA" },
          },
          5: {
            value: { base: "#1C1C1E", _dark: "#EDEDF2" },
          },
          6: {
            value: { base: "#09090A", _dark: "#FCFCFC" },
          },
          7: {
            value: { base: "#09090A", _dark: "#09090A" },
          },
          8: {
            value: { base: "#FCFCFC", _dark: "#FCFCFC" },
          },
        },
      },
      fonts: {
        body: { value: "Poppins" },
        heading: { value: "Poppins" },
        mono: { value: "Poppins" },
      },
    },
  },
});

const mergedConfigs = mergeConfigs(defaultConfig, customConfig);

export default createSystem(mergedConfigs);
